































import { Component, Vue, Watch } from 'vue-property-decorator';
import { namespace, Getter } from 'vuex-class';
import { ActionConstants } from '@/stores/orders/action-constants';
import layout from '@/layouts/app-layout.vue';
import breadcrumb from '@/components/breadcrumb.vue';
import orderList from '@/components/order-list.vue';
import Order from '@/pages/order.vue';
import { Customer } from '@/models/customer';
import { Site } from '@/models/site';

const orderModule = namespace('order');
const userModule = namespace('user');

@Component({
    components: {
        layout,
        breadcrumb,
        orderList,
    },
})
export default class Orders extends Vue {
    public isLoading: boolean = true;
    @orderModule.Getter('totalPages') public totalPages: number;
    @orderModule.Getter('pageSize') public currentPageSize: number;
    @orderModule.Getter('total') public totalOrders: number;
    @orderModule.Getter('orders') public orders: Array<Order>;
    @orderModule.Getter('page') public currentPage: number;
    @orderModule.Getter('filterStatus') public filterStatus: Array<Order>;
    @orderModule.Getter('from') public from: string | null;
    @orderModule.Getter('to') public to: string | null;
    @userModule.Getter('currentCustomer') public currentCustomer: Customer | null;
    @userModule.Getter('currentSite') public currentSite: Site | null;

    @Watch('currentCustomer')
    public async onCustomerChanged(value: Customer): Promise<void> {
        await this.$store.dispatch(ActionConstants.fetch, { status: this.filterStatus, page: this.currentPage, pageSize: this.currentPageSize, from: this.from, to: this.to });
    }
    @Watch('currentSite')
    public async onSiteChanged(value: Site): Promise<void> {
        await this.$store.dispatch(ActionConstants.fetch, { status: this.filterStatus, page: this.currentPage, pageSize: this.currentPageSize, from: this.from, to: this.to });
    }
    public async handlePageChanged(value: number): Promise<void> {
        this.isLoading = true;

        await this.$store.dispatch(ActionConstants.updatePage, value);
        await this.$store.dispatch(ActionConstants.fetch, { status: this.filterStatus, page: this.currentPage, pageSize: this.currentPageSize, from: null, to: null });

        this.isLoading = false;
    }
    public async handleStatusChanged(value: number | string | null): Promise<void> {
        this.isLoading = true;

        await this.$store.dispatch(ActionConstants.updateFilterStatus, value);
        await this.$store.dispatch(ActionConstants.updatePage, 1);
        await this.$store.dispatch(ActionConstants.fetch, { status: this.filterStatus, page: this.currentPage, pageSize: this.currentPageSize, from: this.from, to: this.to });

        this.isLoading = false;
    }
    public async handleFromChanged(value: string | null): Promise<void> {
        this.isLoading = true;

        await this.$store.dispatch(ActionConstants.updateFrom, value);
        await this.$store.dispatch(ActionConstants.updatePage, 1);
        await this.$store.dispatch(ActionConstants.fetch, { status: this.filterStatus, page: this.currentPage, pageSize: this.currentPageSize, from: this.from, to: this.to });

        this.isLoading = false;
    }
    public async handleToChanged(value: string | null): Promise<void> {
        this.isLoading = true;

        await this.$store.dispatch(ActionConstants.updateTo, value);
        await this.$store.dispatch(ActionConstants.updatePage, 1);
        await this.$store.dispatch(ActionConstants.fetch, { status: this.filterStatus, page: this.currentPage, pageSize: this.currentPageSize, from: this.from, to: this.to });

        this.isLoading = false;
    }
    public async mounted(): Promise<void> {
        this.isLoading = true;
        await this.$store.dispatch(ActionConstants.updatePage, 1);
        await this.$store.dispatch(ActionConstants.fetch, { status: this.filterStatus, page: this.currentPage, pageSize: this.currentPageSize, from: this.from, to: this.to });
        this.isLoading = false;
    }
}
